import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { urlConstants } from '../../common/urlConstants';
import { HttpClient } from '@angular/common/http';
import { UpsertEmailDelegationRequest, DeleteEmailDelegationRequest, EmailDelegation, EmailDelegationRequest } from '../../models/substitution.models';

@Injectable({
  providedIn: 'root'
})
export class SubstitutionService {

  constructor(private readonly http: HttpClient) { }

  getEmailDelegation(payload: EmailDelegationRequest): Observable<EmailDelegation[]> {
    const getEmailDelegationURL = `${environment.apiUrl}${urlConstants.getEmailDelegation}`;
    return this.http.post<EmailDelegation[]>(getEmailDelegationURL, payload);
  }

  upsertEmailDelegation(payload: UpsertEmailDelegationRequest): Observable<boolean> {
    const upsertEmailDelegationURL = `${environment.apiUrl}${urlConstants.upsertEmailDelegation}`;
    return this.http.post<boolean>(upsertEmailDelegationURL, payload);
  }

  deleteEmailDelegation(payload: DeleteEmailDelegationRequest): Observable<boolean> {
    const deleteEmailDelegationURL = `${environment.apiUrl}${urlConstants.deleteEmailDelegation}`;
    return this.http.post<boolean>(deleteEmailDelegationURL, payload);
  }
}
